import Api from './api.service';

export default {
  login: (data) => Api.post('auth/clinic-login', data),
  refresh: () => Api.get('auth/refresh'),
};
